import { createAsyncThunk } from '@reduxjs/toolkit';
import { PAGE_ITEMS } from './constants';

const onFetchSnapshot = async ({ timeRange }, { extra: { http } }) => {
  try {
    const result = await http.get(
      `/dashboard/circles?from_epoch_time=${timeRange?.from}&to_epoch_time=${timeRange?.to}`
    );
    return result;
  } catch {}
};

const onFetchVouches = async ({ timeRange, page }, { extra: { http } }) => {
  try {
    const result = await http.get(
      `/vouch?page=${page}&items=${PAGE_ITEMS}&from_epoch_time=${timeRange?.from}&to_epoch_time=${timeRange?.to}`
    );
    return result;
  } catch {}
};

const onFetchTopTalent = async ({ page }, { extra: { http } }) => {
  try {
    const result = await http.get(
      `/user_contacts/top_talent?page=${page}&items=${PAGE_ITEMS}`
    );
    return result;
  } catch {}
};

const onFetchIntroRequested = async (
  { timeRange, page },
  { extra: { http } }
) => {
  try {
    const result = await http.get(
      `/intros/requested?page=${page}&items=${PAGE_ITEMS}&from_epoch_time=${timeRange?.from}&to_epoch_time=${timeRange?.to}`
    );
    return result;
  } catch {}
};

const onFetchIntroMade = async ({ timeRange, page }, { extra: { http } }) => {
  try {
    const result = await http.get(
      `/intros/made?page=${page}&items=${PAGE_ITEMS}&from_epoch_time=${timeRange?.from}&to_epoch_time=${timeRange?.to}`
    );
    return result;
  } catch {}
};

const onFetchIntroPending = async (
  { timeRange, page },
  { extra: { http } }
) => {
  try {
    const result = await http.get(
      `/intros/pending?page=${page}&items=${PAGE_ITEMS}&from_epoch_time=${timeRange?.from}&to_epoch_time=${timeRange?.to}`
    );
    return result;
  } catch {}
};

const onFetchIntroQueue = async ({ timeRange, page }, { extra: { http } }) => {
  try {
    const result = await http.get(
      `/intros/bulk/queue?page=${page}&items=${PAGE_ITEMS}&from_epoch_time=${timeRange?.from}&to_epoch_time=${timeRange?.to}`
    );
    return result;
  } catch {}
};

export const fetchSnapshot = createAsyncThunk(
  'dashboardCircles/snapshot',
  onFetchSnapshot
);

export const fetchVouches = createAsyncThunk(
  'dashboardCircles/vouches',
  onFetchVouches
);

export const fetchTopTalent = createAsyncThunk(
  'dashboardCircles/topTalent',
  onFetchTopTalent
);

export const fetchIntroRequested = createAsyncThunk(
  'dashboardCircles/introTequested',
  onFetchIntroRequested
);

export const fetchIntroMade = createAsyncThunk(
  'dashboardCircles/introMade',
  onFetchIntroMade
);

export const fetchIntroPending = createAsyncThunk(
  'dashboardCircles/introPending',
  onFetchIntroPending
);

export const fetchIntroQueue = createAsyncThunk(
  'dashboardCircles/introQueue',
  onFetchIntroQueue
);
